import { Button, CircularProgress, Divider, Stack, Typography } from "@mui/material";
import { Elements, PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useEffect, useState } from "react";
import show from "../../../api/auth/orders/show";
import create from "../../../api/auth/orders/paymentIntents/create";
import index from "../../../api/auth/customers/paymentMethods";
import CreditCard from "./CreditCard";
import confirm from "../../../api/auth/orders/paymentIntents/confirm";
import destroy from "../../../api/auth/customers/paymentMethods/destroy";

const OrderCreditCardCheckoutForm = ({ order, clientSecret, returnUrl, confirmAmount, afterSuccess }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [ submitting, setSubmitting ] = useState(false);

  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);

    if (elements == null) {
      return;
    }

    // Trigger form validation and wallet collection
    const {error: submitError} = await elements.submit();
    if (submitError) {
      // Show error to your customer
      setErrorMessage(submitError.message);
      return;
    }

    const {error} = await stripe.confirmPayment({
      //`Elements` instance that was used to create the Payment Element
      elements,
      clientSecret,
      confirmParams: {
        return_url: returnUrl || `https://ims.wush.life/orders/${order.id}`,
      },
      redirect: 'if_required',
    });

    if (error) {
      // This point will only be reached if there is an immediate error when
      // confirming the payment. Show error to your customer (for example, payment
      // details incomplete)
      setErrorMessage(error.message);
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
      show(order?.id, (response) => {
        setTimeout(() => {
          afterSuccess(response);
        }, 500);
      });
    }
  };

  console.log(stripe, elements);

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <Stack direction="row" mt={2} width="100%" justifyContent="center">
        <Button width="220px" variant="contained" type="submit" disabled={!stripe || !elements || submitting}>
          Pay (${confirmAmount / 100})
        </Button>
      </Stack>
      {/* Show error message to your customers */}
      {errorMessage && <div>{errorMessage}</div>}
    </form>
  );
};

const OrderCreditCardCheckout = ({ order, returnUrl, allowPastPaymentMethods, afterSuccess }) => {
  const [ paymentMethods, setPaymentMethods ] = useState(null);
  const [ selectedPaymentMethod, setSelectedPaymentMethod ] = useState(order.setup_intent_payment_method_id);
  const [ clientSecret, setClientSecret ] = useState(null);
  const [ confirmAmount, setConfirmAmount ] = useState(null);
  const [ stateOrder, setStateOrder ] = useState(null);
  const [ submitting, setSubmitting ] = useState(false);

  useEffect(() => {
    show(order?.id, (response) => {
      setStateOrder(response);
    });
    create(order?.id, (response) => {
      setClientSecret(response.client_secret);
      setConfirmAmount(response.amount);
    });
  }, [order]);

  useEffect(() => {
    if(allowPastPaymentMethods) {
      index(order?.customer_id, (response) => {
        setPaymentMethods(response);
      });
    }
  }, []);

  console.log(stateOrder, clientSecret);

  if(!stateOrder || !clientSecret) {
    return <CircularProgress />;
  }

  const stripePromise = loadStripe(stateOrder.stripe_publishable_key);

  const options = {
    clientSecret: clientSecret,
    // Fully customizable with appearance API.
    appearance: {
      /*...*/
    },
  };

  const handleSubmit = () => {
    setSubmitting(true);
    confirm(order?.id, selectedPaymentMethod, (response) => {
      console.log(response);
      setTimeout(() => {
        afterSuccess(response);
      }, 500);
    });
  };

  const handleRemovePaymentMethod = (paymentMethodId) => {
    console.log("remove payment method");
    destroy(order?.customer_id, paymentMethodId, () => {
      setPaymentMethods(paymentMethods.filter((paymentMethod) => paymentMethod.id !== selectedPaymentMethod));
    });
  };

  return (
    <Stack>
      <Stack>
        {paymentMethods?.length > 0 &&
          <Stack>
            <Stack>
              <Typography variant="h6">Past payment methods</Typography>
            </Stack>
            {paymentMethods.map((paymentMethod) => (
              <Stack key={paymentMethod.id} mb={1}>
                <CreditCard
                  card={paymentMethod.card}
                  onClick={() => setSelectedPaymentMethod(paymentMethod.id)}
                  selected={selectedPaymentMethod === paymentMethod.id}
                  handleDelete={() => handleRemovePaymentMethod(paymentMethod.id)}
                />
              </Stack>
            ))}
            <Divider sx={{ my: 2 }} />
          </Stack>
        }
      </Stack>
      {!selectedPaymentMethod && <Elements stripe={stripePromise} options={options}>
        <OrderCreditCardCheckoutForm order={order} clientSecret={clientSecret} returnUrl={returnUrl} confirmAmount={confirmAmount} afterSuccess={afterSuccess} />
      </Elements>}
      {selectedPaymentMethod && <Stack direction="row" spacing={2}>
        <Button disabled={submitting} variant="contained" onClick={handleSubmit}>Pay (${confirmAmount / 100})</Button>
        <Button disabled={submitting} onClick={() => setSelectedPaymentMethod(null)}>New Payment Method</Button>
      </Stack>}
    </Stack>
  );
};

export default OrderCreditCardCheckout;